import CommPreferences from 'pages/account/comm-preferences-v2';

export default function CommunicationPreferencesPage() {
  return <CommPreferences />;
}
